import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Banner from "../../common/Banner";
import Slider from "../../common/Slider";
import { setHeading } from "../../../redux/slice/headerSlice";
import { GOLD, HOME_ACCORDIAN } from "../../../utils/constant";
import { customerView, getCustomerGiftcard, getMilestone, getQualifiedCamp, getRewardData } from "../../auth/auth";
import Loader from "../../partial/Loader";
import { formatPointData, formatPoints, getDate } from "../../../utils/helper";
import { setProfileData } from "../../../redux/slice/authSlice";
import { handleClaimModal } from "../../../redux/slice/modalSlice";
import Header from "../../layout/Header";
import AESSecurity, { decryptData } from "../../../utils/AESSecurity";


const Homepage = () => {
  const navigate = useNavigate()
  const [showPopup, setShowPopup] = useState(false);
  const [popupReward, setPopupReward] = useState(null);
  const [totalMatchedPoints, setTotalMatchedPoints] = useState(0);
  const [unqualifiedCampaign, setUnqualifiedCampaign] = useState(0)
  const tiers = localStorage.getItem("customerTier");
  const InvoiceEarningsStatus = localStorage.getItem("InvoiceEarningsStatus");
  const [response, setResponse] = useState([]);
  const [customerDetail, setCustomerDetail] = useState();
  const [tierHistory, setTierHistory] = useState();
  const [earningMilestone, setEarningMilestone] = useState();
  const [walletsDetail, setWalletsDetail] = useState();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const [isWlcmOfferClaimed, setIsWlcmOfferClaimed] = useState();
  const [giftCards, setGiftCards] = useState([]);
  const memberShip = useSelector((state) => state.membership.memberShip);

  const activityPointsMap = {
    'ERP Daily Sync': {
      Silver: 1000,
      Gold: 1500,
      Platinum: 2000,
      "Founder Club": 2500,
    },
    'Onboard Retailers': {
      Silver: 125000,
      Gold: 250000,
      Platinum: 375000,
      "Founder Club": 500000,
    },
    'Refer Brands': {
      Silver: 3700000,
      Gold: 7500000,
      Platinum: 10000000,
      "Founder Club": 15000000,
    },
    'Refer Distributors': {
      Silver: 500000,
      Gold: 1000000,
      Platinum: 1500000,
      "Founder Club": 2000000,
    },
  };




  useEffect(() => {
    dispatch(setHeading("Loyalty Rewards"));
    fetchCustData();
  }, []);
  // const datasss = "Ls56SlD7Tcc2LH8lrTABN9rmtpCxiYlP40CKKccrPPybu4LLcnFg9lfou/dfwcqvOWVX0Z44cRTDVNENgqLfak3ys3+GLlQPZgSc+h/IzM04lJwvh86UCWmMb5rsASehxrVJnUkFji46I2AqsVw2RUct1mBUN72xINtSL3yXS2VIezp4Ze7ln37xjT9bYy+CynCo75CYxRdmRfhUCGziGx9Z23BrJM6MGbioI3PWv1h/UOnQuPHLlk2zpD184UavgFVwQFP5jW7sUcam8ysoeAKw5CE/0CVkUsIwoAjMsXn0fsMlMUtYe6VsyUqyQBGjBcg6H01aoVRz+00/7vZGldfsJ/C05Bm/2295rwX7CMYn3AzeBAzgNvP5SFI54m8XgoNrgHESJ/nynPzmxyqciojb7slFPiqG/+hR4HCN4Gf25hHnP3tMB5NM5xzv2K+KE+oeay1qhBB2PZ9F9ftiu3Twt0vvF6DBx87W8riWGf7uYlU8L7HRTySxGhc137Et"

  //  const encryptedData = decryptData(datasss);
  const parseCustomDate = (dateStr) => {
    const [datePart, timePart, period] = dateStr.split(" ");
    const [month, day, year] = datePart.split("/");
    const [hours, minutes, seconds] = timePart.split(":");
    let hour = parseInt(hours, 10);
    if (period === "PM" && hour !== 12) hour += 12;
    if (period === "AM" && hour === 12) hour = 0;
    return new Date(year, month - 1, day, hour, minutes, seconds);
  };
  const token = JSON.parse(localStorage.getItem("token_gen"));
  const tokenfull = localStorage.getItem("fulfil_token");
  const customerid = localStorage.getItem("customerid");
  const fetchCustData = async () => {
    setLoader(true);
    const customerCode = localStorage.getItem("customercode");
    const quarterlypoints = localStorage.getItem('quarterlypoints');

    const customerPromise = customerView(token.access_token, customerCode);
    const qualifiedCampPromise = getQualifiedCamp(token.access_token, customerCode);
    const milestonePromise = getMilestone(token.access_token, customerid);
    const giftCardResponse = await getCustomerGiftcard(tokenfull);
    const quarterlypoint = quarterlypoints > 20000 ? 20000 : quarterlypoints
    const rewardResponse = getRewardData(token.access_token, 'MER000325', quarterlypoint)

    Promise.all([customerPromise, qualifiedCampPromise, milestonePromise, giftCardResponse, rewardResponse])
      .then(([profileData, campData, miledata, giftCard, rewardData]) => {
        setWalletsDetail(profileData?.walletsDetail);
        setGiftCards(giftCard || []);
        setEarningMilestone(miledata);
        const uniqueRewards = (rewardData?.data || []).filter(
          (item, index, self) =>


            index === self.findIndex(r => r.id === item.id)
        );
        setResponse(uniqueRewards);
        const customerData = profileData?.transactions || [];
        const data = miledata?.data?.[0] || {};
        const activities = data.Activity || [];
        const bonusActivities = data.BonusActivities || [];

        const customerCreatedDate = data.Customer?.createdDate;
        if (customerCreatedDate && customerData.length > 0) {
          const filteredCustomerDetails = customerData.filter(
            (detail) => new Date(detail.createdDate) > parseCustomDate(customerCreatedDate)
          );
          const allCampaignCodes = [
            ...activities.map((activity) => activity.campaignCode),
            ...bonusActivities.map((bonusActivity) => bonusActivity.campaignCode),
          ];
          const customerCampaignValues = customerData
            .flatMap((detail) => detail.qualifiedCampaign || [])
            // .filter((qc) => qc.walletFor === "Customer" && allCampaignCodes.includes(qc.campaignId))
            .filter((qc) => qc.walletFor === "Customer")
            .reduce((sum, qc) => sum + (qc.value || 0), 0);
          setTotalMatchedPoints(customerCampaignValues);
        }
        localStorage.setItem("customerTier", profileData?.customer?.customertier);
        localStorage.setItem("customerid", profileData?.customer?.companyid);
        localStorage.setItem("industry", profileData?.customer?.industry);
        localStorage.setItem("Total_earning_month", profileData?.customer?.Total_earning_month);
        localStorage.setItem("Avg_Invoice_Disbursed_per_month", profileData?.customer?.Avg_Invoice_Disbursed_per_month);

        localStorage.setItem("quarterlypoints", profileData?.customer?.quarterlypoints);
        localStorage.setItem("npaBreached", profileData?.customer?.npaBreached);
        localStorage.setItem("earnedValue", profileData?.walletsDetail?.earnedValue);
        localStorage.setItem("iseligibleforERPEarning", profileData?.customer?.iseligibleforERPEarning);
        setCustomerDetail(profileData?.customer);
        setUnqualifiedCampaign(profileData?.unqualifiedtotalPointsEarned);
        setTierHistory(profileData?.tierHistory?.[0])
        setIsWlcmOfferClaimed(campData?.data);
      })
      .catch((error) => {
        console.error("Error in API calls", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handlePopup = (reward) => {
    setPopupReward(reward);
    setShowPopup(true);
  };
  useEffect(() => {
    const video = document.getElementById("video");
    const circlePlayButton = document.getElementById("circle-play-b");

    if (!video || !circlePlayButton) return;

    const togglePlay = () => {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    };

    circlePlayButton.addEventListener("click", togglePlay);
    video.addEventListener("playing", handlePlaying);
    video.addEventListener("pause", handlePause);

    function handlePlaying() {
      circlePlayButton.style.opacity = 0;
    }

    function handlePause() {
      circlePlayButton.style.opacity = 1;
    }

    return () => {
      circlePlayButton.removeEventListener("click", togglePlay);
      video.removeEventListener("playing", handlePlaying);
      video.removeEventListener("pause", handlePause);
    };
  }, []);

  // useEffect(() => {
  //   const fetchGiftCards = async () => {
  //     try {
  //       const id = localStorage.getItem("Id");
  //       const tokenn = localStorage.getItem("fulfil_token");
  //       const giftCardResponse = await getCustomerGiftcard(tokenn, "MER000325", "");
  //       setGiftCards(giftCardResponse || []);
  //     } catch (error) {
  //       console.error("Error fetching gift cards:", error);
  //     }
  //   };

  //   fetchGiftCards();
  // }, []);

  const swiperConfig = {
    direction: "horizontal",
    loop: false,
    grabCursor: true,
    speed: 800,
    navigation: false,
    slidesPerView: 1.3,
    spaceBetween: 15,
    pagination: false,
    dots: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
    },
  };

  const restrictedCampaignIds = [
    "NTH-CAM001988",
    "NTH-CAM001989",
    "NTH-CAM001990",
    "NTH-CAM001991",
  ];
  const formatRewardContent = (content) => {
    return content.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < content.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const isRestrictedCampaignPresent = isWlcmOfferClaimed?.distinctCampaignData
    ? isWlcmOfferClaimed.distinctCampaignData.some((item) => {
      const campaignId = item?.campaignId;
      return campaignId && restrictedCampaignIds.includes(campaignId);
    })
    : false;



  const convertGoal = earningMilestone?.data && (earningMilestone?.data[0]?.RewardsDetails?.totalpoint / 1000);
  const convertEarn = totalMatchedPoints / 1000;
  const totalpercent = earningMilestone?.data &&
    `${Math.min((totalMatchedPoints / earningMilestone?.data[0]?.RewardsDetails?.totalpoint) * 100, 100).toFixed()}%`;



  const currentDate = new Date();
  const endDateString = (earningMilestone?.data && (earningMilestone?.data[0]?.Timeline?.EndDate));
  const endDate = new Date(endDateString);
  const timeDiff = endDate - currentDate;
  const isGoalExpired = endDate && endDate < currentDate && totalpercent !== "100.00%";
  const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  const overallProgress = earningMilestone?.data &&
    `${Math.round(Math.min((totalMatchedPoints / earningMilestone?.data[0]?.RewardsDetails?.totalpoint) * 100, 100))}%`

  const shouldShowTierHistory = (tierHistory) => {
    if (!tierHistory || !tierHistory.createdAt || !tierHistory.type) {
      return false;
    }
    const createdAt = new Date(tierHistory.createdAt);
    const currentDate = new Date();
    const diffInMs = currentDate - createdAt;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    return diffInDays <= 2;
  };
  const getDowngradeDisplay = (currentTier) => {
    const tierPoints = {
      Silver: '1x',
      Gold: '1.5x',
      Platinum: '2x',
      'Founder Club': '2.5x',
    };

    switch (currentTier) {
      case 'Gold':
        return { tier: 'Silver', points: tierPoints.Silver };
      case 'Platinum':
        return { tier: 'Gold', points: tierPoints.Gold };
      case 'Founder Club':
        return { tier: 'Platinum', points: tierPoints.Platinum };
      default:
        return { tier: 'Inactive', points: '' };
    }
  };
  let points = 0;
  if (tiers === "Silver") points = 100;
  else if (tiers === "Gold") points = 150;
  else if (tiers === "Platinum") points = 200;
  else if (tiers === "Founder Club") points = 250;
  const industry = localStorage.getItem('industry');
  const industryTransactionMap = {
    'White Goods': 10000,
    'Steel': 10000,
    'Battery': 10000,
    'Ceramics': 10000,
    'Construction': 10000,
    'Spare': 10000,
    'Footwear': 10000,
    'Glass & Plywood': 10000,
    'Plywood': 10000,
    'Glass': 10000,
    'Mobile': 20000,
    '2 Wheelers': 12500,
    'Agri Inputs': 8000,
    "FMCG": 10000
  };
  const transactionValue = industryTransactionMap[industry]

  const display = getDowngradeDisplay(tiers);
  const goToPreviousTab = () => {
    window.location.href = "https://app.progfin.com/#/home?tab=Home"
  };
  return (
    <>
      <Header goToPreviousTab={goToPreviousTab} isHomePage={true} />
      <main>
        {loader && <Loader />}
        {!isRestrictedCampaignPresent && (
          <Banner tiers={tiers} />
        )}
        <div style={{ marginTop: "10px" }}>
          {localStorage.getItem("npaBreached").toLowerCase() === "yes" ? (
            <div className="home-membership">
              <div className="home-membership-top">
                <div className="home-membership-top-header">
                  <h3>{tiers} Membership</h3>
                  <span className="hold">On Hold</span>
                </div>
                <div className="alert-box danger">
                  <div className="alert-box-message">
                    <p className="mb-05">Membership benefits temporarily suspended</p>
                    <p>Current overdues exceed the maximum limit of 5%</p>
                  </div>
                </div>
              </div>
              <div className="home-membership-bottom">
                <Link to="/membership?tab=benefits" state={{ pointsData: totalpercent }} className="hold">
                  <img src="images/benefit_colored_bold_red.png" alt="" />
                  View Membership Benefits
                </Link>
              </div>
            </div>
          ) : (
            <div className="home-membership">
              {shouldShowTierHistory(tierHistory) ? (
                tierHistory.type === "Downgrade" ? (
                  <div className="home-membership-top">
                    <div className="home-membership-top-header">
                      {tierHistory?.newTier === "Not Eligible" ?
                        <h3>Membership Inactive</h3>
                        :
                        <h3>{tierHistory?.newTier} Membership</h3>}
                      <span className="downgrade">{tierHistory?.newTier === "Silver" ? "1x" : tierHistory?.newTier === "Gold" ? "1.5x" : tierHistory?.newTier === "Platinum" ? "2x" : tierHistory?.newTier === "Founder Club" ? "2.5x" : "0"} Points</span>
                    </div>
                    <div className="home-membership-top-body downgrade">
                      {tierHistory?.newTier === "Not Eligible" ?
                        <h6>Your Silver membership is currently inactive</h6> :
                        <h6>Membership downgraded from {tierHistory?.oldTier} ({tierHistory?.oldTier === "Silver" ? "1x" : tierHistory?.oldTier === "Gold" ? "1.5x" : tierHistory?.oldTier === "Platinum" ? "2x" : tierHistory?.oldTier === "Founder Club" ? "2.5x" : "0"} points) to {tierHistory?.newTier} ({tierHistory?.newTier === "Silver" ? "1x" : tierHistory?.newTier === "Gold" ? "1.5x" : tierHistory?.newTier === "Platinum" ? "2x" : tierHistory?.newTier === "Founder Club" ? "2.5x" : "0"} points)</h6>

                      }   </div>
                  </div>
                ) : tierHistory.type === "Upgrade" ? (
                  <div className="home-membership-top">
                    <div className="home-membership-top-header">
                      <h3>{tiers} Membership</h3>
                      <span className="upgrade">{tierHistory.type}</span>
                    </div>
                    <div className="home-membership-top-body upgrade">
                      <h6>Congratulations on your upgrade!</h6>
                      <p>
                        You now earn {tiers === "Silver" ? "1x" : tiers === "Gold" ? "1.5x" : tiers === "Platinum" ? "2x" : tiers === "Founder Club" ? "2.5x" : "0"} points on all transactions
                      </p>
                    </div>
                  </div>
                ) : null
              ) : (
                tiers === "Silver" ? (
                  <div className="home-membership-top">
                    <div className="home-membership-top-header">
                      <h3>Silver Membership</h3>
                      <span>1x Points</span>
                    </div>
                    {tiers === "Silver" ? <p>Enjoy a chance to win premium rewards on every invoice disbursal</p> :

                      <p>Enjoy a chance to win premium rewards</p>}
                  </div>
                ) : tiers === "Gold" ? (
                  <div className="home-membership-top">
                    <div className="home-membership-top-header">
                      <h3>Gold Membership</h3>
                      <span>1.5x Points</span>
                    </div>
                    <p>Earn 1.5x points on all transactions</p>
                  </div>
                ) : tiers === "Platinum" ? (
                  <div className="home-membership-top">
                    <div className="home-membership-top-header">
                      <h3>Platinum Membership</h3>
                      <span>2x Points</span>
                    </div>
                    <p>Earn 2x points on all transactions</p>
                  </div>
                ) : tiers === "Founder Club" ? (
                  <div className="home-membership-top">
                    <div className="home-membership-top-header">
                      <h3>Founder Club</h3>
                      <span>2.5x Points</span>
                    </div>
                    <p>Earn 2.5x points on all transactions</p>
                  </div>
                ) : (
                  <div className="home-membership-top">
                    <div className="home-membership-top-header">
                      <h3></h3>
                      <span>0 Points</span>
                    </div>
                    <p>Earn 0% more points on all transactions</p>
                  </div>
                )
              )}
              <div className="home-membership-bottom">
                <Link to="/membership?tab=benefits" state={{ pointsData: totalpercent }} className="">
                  <img src="/images/benefit_colored_bold.png" alt="" />
                  View Membership Benefits
                </Link>
              </div>
            </div>
          )}
          {customerid === "13217511" && (
            <>
              {earningMilestone?.data == null ? (
                <div className="home-goals">
                  {InvoiceEarningsStatus?.toLowerCase() === "no" ?
                    <>
                      {/* <div className="overlay_lock">
                    <span className="lock_icon">
                      <i class="fa-solid fa-lock"></i>
                      <p className="message1">{customerDetail?.InvoicedLockedReason}</p>
                    </span>
                  </div> */}
                      <Link to="" className="home-goals-main">
                        <div className="home-goals-main-header">
                          <div className="home-goals-main-header-left">
                            <span>
                              <img src="images/target.png" alt="" />
                            </span>
                          </div>
                          <div className="home-goals-main-header-right">
                            <h5>Step 1: Set Up a Goal</h5>
                            <p>Set your goal, achieve it and get rewarded</p>
                          </div>
                        </div>
                      </Link>

                    </>
                    :
                    <>
                      {/* <span className="lock_icon">
            <i class="fa-solid fa-lock"></i>
          </span> */}
                      <Link to="/reward" className="home-goals-main">
                        <div className="home-goals-main-header">
                          <div className="home-goals-main-header-left">
                            <span>
                              <img src="images/target.png" alt="" />
                            </span>
                          </div>
                          <div className="home-goals-main-header-right">
                            <h5>Step 1: Set Up a Goal</h5>
                            <p>Set your goal, achieve it and get rewarded</p>
                          </div>
                        </div>
                      </Link>
                    </>
                  }
                </div>
              ) : totalpercent === "100.00%" ? (
                <div className="home-goals complete">
                  <Link to="/track-timeline">
                    <div className="home-goals-top">
                      <div className="home-goals-top-header">
                        <div className="home-goals-top-header-left">
                          <span className="complete">
                            <img src="images/party.png" alt="" />
                          </span>
                        </div>
                        <div className="home-goals-top-header-right">
                          <h4>Goal Achieved</h4>
                          <p className="complete">Completed on {endDateString}</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                  <div className="home-goals-middle">
                    <div className="home-goals-middle-top">
                      <div className="home-goals-middle-top-left">Final Progress</div>
                      <div className="home-goals-middle-top-right" >
                        {formatPoints(convertGoal * 1000)} points <span className="goal-progress">{totalpercent}</span>
                      </div>
                    </div>
                    <div className="home-goals-middle-bottom">
                      <div className="home-goals-progress-container complete">
                        <div
                          className="timeline-track-progress-fill"
                          style={{ width: overallProgress || '0%' }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="home-goals-bottom complete mb-15">
                    <div className="home-goals-bottom-left">
                      <h5>Reward earned</h5>
                      <p>{earningMilestone?.data[0]?.RewardsDetails?.Name}</p>
                    </div>
                    <div className="home-goals-bottom-right">
                      <span className="complete">
                        <img src="images/trophy_colored.png" alt="" />
                      </span>
                    </div>
                  </div>
                  <div className="home-goals-button">
                    <a href="#" className="btn btn-success btn-block">
                      <span>Claim Your Reward</span>
                    </a>
                  </div>
                </div>
              ) : isGoalExpired ? (
                <div className="home-goals expired">
                  <Link to="/track-timeline" className="home-goals-top">
                    <div className="home-goals-top-header">
                      <div className="home-goals-top-header-left">
                        <span className="expired">
                          <img src="/images/target-expired.png" alt="" />
                        </span>
                      </div>
                      <div className="home-goals-top-header-right">
                        <h4>Goal Expired</h4>
                        <p className="expired">Ended on {endDateString}</p>
                      </div>
                    </div>
                  </Link>
                  <div className="home-goals-middle">
                    <div className="home-goals-middle-top">
                      <div className="home-goals-middle-top-left">Progress</div>
                      <div className="home-goals-middle-top-right" >
                        {formatPoints(convertEarn * 1000)} / {formatPoints(convertGoal * 1000)} points <span className="goal-progress">{totalpercent}</span>
                      </div>
                    </div>
                    <div className="home-goals-middle-bottom">
                      <div className="home-goals-progress-container expired">
                        <div
                          className="timeline-track-progress-fill"
                          style={{ width: overallProgress || '0%' }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="home-goals-bottom expired mb-15">
                    <div className="home-goals-bottom-left">
                      <h5>Reward Missed</h5>
                      <p>{earningMilestone?.data[0]?.RewardsDetails?.Name}</p>
                    </div>
                    <div className="home-goals-bottom-right">
                      <span className="expired">
                        <img src="/images/trophy_expired.png" alt="" />
                      </span>
                    </div>
                  </div>
                  <div className="home-goals-button">
                    <Link to="/reward" className="btn btn-secondary btn-block btn-disabled">
                      <span>Set a New Goal</span>
                    </Link>
                  </div>
                </div>
              ) : (
                <div className="home-goals">
                  <Link to="/track-timeline" className="home-goals-top">
                    <div className="home-goals-top-header">
                      <div className="home-goals-top-header-left">
                        <span>
                          <img src="/images/target.png" alt="" />
                        </span>
                      </div>
                      <div className="home-goals-top-header-right">
                        <h4>Goal Progress</h4>
                        <p>{daysLeft} Days Left</p>
                      </div>
                    </div>
                  </Link>
                  <div className="home-goals-middle">
                    <div className="home-goals-middle-top">
                      <div className="home-goals-middle-top-left">Progress</div>
                      <div className="home-goals-middle-top-right" >
                        {formatPoints(convertEarn * 1000)} / {formatPoints(convertGoal * 1000)} points <span className="goal-progress">{`(${totalpercent})`}</span>
                      </div>
                    </div>
                    <div className="home-goals-middle-bottom">
                      <div className="home-goals-progress-container">
                        <div
                          className="timeline-track-progress-fill"
                          style={{ width: overallProgress || '0%' }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="home-goals-bottom">
                    <div className="home-goals-bottom-left">
                      <h5>Reward on completion</h5>
                      <p>{earningMilestone?.data[0]?.RewardsDetails?.Name}</p>
                    </div>
                    <div className="home-goals-bottom-right">
                      <span>
                        <img src="/images/trip.png" alt="" />
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          <div className="home-points">
            <div className="home-points-heading">
              <h4>Points Summary</h4>
            </div>
            <div className="home-points-box">
              <div className="home-points-box-top">
                <div className="home-points-box-top-left">
                  <h3>{formatPointData(walletsDetail?.earnedValue + unqualifiedCampaign || 0)}</h3>
                  {/* <p style={{ fontSize: "16px", marginTop: "10px" }}>
                    (₹
                    {formatPoints((walletsDetail?.earnedValue + unqualifiedCampaign) / 100 || 0)})
                  </p> */}

                  <p style={{ fontSize: "16px", marginTop: "10px" }}>Points Earned</p>
                </div>
                <div className="home-points-box-top-right">
                  <h3>{formatPoints(walletsDetail?.availableValue || 0)}</h3>
                  {/* <p style={{ fontSize: "16px", marginTop: "10px" }}>
                    (₹
                    {formatPoints(walletsDetail?.availableValue / 100 || 0)})
                  </p> */}
                  <p style={{ fontSize: "16px", marginTop: "10px" }}>Points Unlocked</p>
                </div>
              </div>
              <div className="home-points-box-bottom">
                <Link to="/transaction-rewards" className="btn btn-block btn-primary">
                  <span>View Account Statement</span>
                </Link>
              </div>
            </div>
          </div>

          {/* <div className="home-regain">
        <div className="home-regain-box redbg">
          <div className="home-regain-box-top">
            <h5><img src='images/retailer_red.png' alt=""/> 5/7 Active Retailers</h5>
          </div>
          <div className="home-regain-box-middle">
            <div className="home-regain-box-middle-top">
              <h3><img src='images/crown_red.png' alt=""/> Regain Silver Benefits</h3>
            </div>
            <div className="home-regain-box-middle-bottom">
              <p>Add 2 more active retailers to regain Silver benefits</p>
            </div>
          </div>
          <div className="home-regain-box-bottom">
            <Link to="/transaction-rewards" className="btn-empty btn-empty-with-arrow red">
              <span>View Requirements</span>
            </Link>
          </div>
        </div>
      </div> */}
          <div className={`reward-slider-wrapper ${showPopup ? "popup-active" : ""}`}>
            <Slider header="Rewards"
              slides={response?.map((res, index) =>
              (
                <div className="featured-slide-box" style={{ cursor: "pointer" }} onClick={() => handlePopup(res)} key={index}>

                  <div className="featured-slide-box-image">
                    <div className="overlay_lock">
                      <span className="lock_icon">
                        <i class="fa-solid fa-lock"></i>
                        {/* <p className="message1">{customerDetail?.InvoicedLockedReason}</p> */}
                      </span>
                    </div>
                    <img src={res.imageUrl} alt={res.reward} />

                  </div>

                  <div className="featured-slide-box-inner">
                    <div className="featured-slide-box-inner-heading">
                      <h5>{res.reward}</h5> </div>
                    <p>{res.reward_display || "No description available"}
                    </p> <div className="featured-slide-box-inner-points">
                      <p> {`${formatPoints(parseInt(res.amount_required * 100))} Points`}
                      </p>  </div> {/* <Link to="" className="btn btn-primary btn-block"> <span>Redeem Reward</span> </Link> */}
                    <div className='timeline-rewards-box-content-inner'>
                      <div className='timeline-rewards-box-content-inner-left' >
                        <button onClick={() => handlePopup(res)} style={{ whiteSpace: "nowrap" }}
                          className='text-blue-500'> View details </button> </div> </div> </div> </div>)) || []} />
          </div>
          {showPopup && popupReward && (
            <div className='popup show'>
              <div className='popup-box reward-box'>
                <Link
                  to=''
                  className='close-popup'
                  onClick={() =>
                    setShowPopup(false)
                  }>
                  X
                </Link>
                <div className='popup-box-inner'>
                  {/* Render formatted content */}
                  <p>
                    {formatRewardContent(
                      popupReward.reward_display,
                    )}
                  </p>
                  <p className='points'>
                    {formatPoints(
                      popupReward?.amount_required * 100,
                    )}{' '}
                    Points Required
                  </p>
                </div>
              </div>
            </div>
          )}
          <Slider
            header="Start Earning Points"
            slides={[
              <div className="swiper-slide-box swiper-slide-box-1">
                {InvoiceEarningsStatus?.toLowerCase() === "no" &&
                  <div className="overlay_lock">
                    <span className="lock_icon">
                      <i class="fa-solid fa-lock"></i>
                      {/* <p className="message1">{customerDetail?.InvoicedLockedReason}</p> */}
                    </span>
                  </div>}
                <img src="/images/invoice.png" alt="" />
                <h5>Earn on Invoice Uploads</h5>
                <p>{`${points} points for every ₹${formatPoints(transactionValue)} invoice value`}</p>
                <Link to="/route-invoice" className="btn btn-white btn-color btn-shadow">
                  <span>View Details</span>
                </Link>
              </div>,
              <div className="swiper-slide-box swiper-slide-box-2">
                <img src="/images/refer_brand.png" alt="" />
                <h5>Refer a Brand</h5>
                {/* <p>Earn up to {formatPoints(activityPointsMap['Refer Brands'][tiers] || 0)} points for each successful brand referral</p>
            <Link to="/refer-a-brand" state={{ pointsData: formatPoints(activityPointsMap['Refer Brands'][tiers] || 0) }} className="btn btn-white btn-color btn-shadow">
              <span>Refer Now</span>
            </Link> */}
                <p>Earn up to &#x20B9;50k  for each successful brand referral</p>
                <Link to="/refer-a-brand" state={{ pointsData: "50k" }} className="btn btn-white btn-color btn-shadow">
                  <span>Refer Now</span>
                </Link>
              </div>,
              <div className="swiper-slide-box swiper-slide-box-3">
                <img src="/images/refer_distributor.png" alt="" />
                <h5>Refer a Distributor</h5>
                {/* <p>Earn up to {formatPoints(activityPointsMap['Refer Distributors'][tiers] || 0)} points for each successful distributor referral</p>
            <Link to="/refer-a-distributor" state={{ pointsData: formatPoints(activityPointsMap['Refer Distributors'][tiers] || 0) }} className="btn btn-white btn-color btn-shadow">
              <span>Refer Now</span>
            </Link> */}
                <p>Earn up to &#x20B9;10k  for each successful distributor referral</p>
                <Link to="/refer-a-distributor" state={{ pointsData: "10k" }} className="btn btn-white btn-color btn-shadow">
                  <span>Refer Now</span>
                </Link>
              </div>,
              <>{industry === "FMCG" ? null :
                <div className="swiper-slide-box swiper-slide-box-4">
                  <img src="/images/refer_retailer.png" alt="" />
                  <h5>Refer a Retailer</h5>
                  {/* <p>Earn up to {formatPoints(activityPointsMap['Onboard Retailers'][tiers] || 0)} points for each successful retailer referral</p>
            <Link to="/refer-a-retailer" state={{ pointsData: formatPoints(activityPointsMap['Onboard Retailers'][tiers] || 0) }} className="btn btn-white btn-color btn-shadow">
              <span>Refer Now</span>
            </Link> */}
                  <p>Earn 1L bonus points for each successful retailer referral</p>
                  <Link to="/refer-a-retailer" state={{ pointsData: "10k" }} className="btn btn-white btn-color btn-shadow">
                    <span>Refer Now</span>
                  </Link>
                </div>}
              </>,
              customerDetail?.iseligibleforERPEarning?.toLowerCase() === "yes" ? (
                <div className="swiper-slide-box swiper-slide-box-5">
                  <img src="/images/erp_sync.png" alt="ERP Sync" />
                  <h5>Enable ERP Sync</h5>
                  <p>Earn {formatPoints(activityPointsMap['ERP Daily Sync'][tiers] || 0)} points every day by keeping your ERP synced with Progcap</p>
                  <Link className="btn btn-white btn-color btn-shadow" to="/erp-sync" state={{ pointsData: formatPoints(activityPointsMap['ERP Daily Sync'][tiers] || 0) }}>
                    <span>View Details</span>
                  </Link>
                </div>
              ) : null,
            ]}
            swiperConfig={swiperConfig}
            className="home-Swiper"
          />

          {customerDetail?.npaBreached?.toLowerCase() === "yes" ? (
            <div className="home-benefits">
              <div className="home-benefits-box alert">
                <div className="home-benefits-box-top">
                  <img src="/images/danger.png" alt="" />
                  Action Required
                </div>
                <div className="home-benefits-box-middle">

                  <p>
                    Clear overdues to restore your membership benefits
                  </p>
                </div>
                <Link to="" className="btn btn-empty red pl-0">
                  <span>View Details <img src="images/arrow_colored_red.png" width={15} /></span>
                </Link>
              </div>
            </div>
          ) :
            tiers === "Founder Club" ? null : (
              <div className="home-benefits">
                <div className="home-benefits-box">
                  <div className="home-benefits-box-top">
                    <img src="/images/rising_gold.png" alt="" />
                    {customerDetail?.tierachievedpercent}% Progress to{" "}
                    {tiers === "Silver" ? "Gold" : tiers === "Gold" ? "Platinum" : "Founder Club"}
                  </div>
                  <div className="home-benefits-box-middle">
                    <h4 className="home-benefits-box-middle-top">
                      <img src="/images/crown_new.png" alt="" />
                      Unlock {tiers === "Silver" ? "Gold" : tiers === "Gold" ? "Platinum" : "Founder Club"} Benefits!
                    </h4>
                    <p>
                      You're on track to earn{" "}
                      <span>
                        {tiers === "Silver" ? "1.5x" : tiers === "Gold" ? "2x" : "2.5x"} points
                      </span>{" "}
                      on all transactions with{" "}
                      {tiers === "Silver" ? "Gold" : tiers === "Gold" ? "Platinum" : "Founder Club"} membership
                    </p>
                  </div>
                  <Link to="/membership" className="btn btn-empty pl-0">
                    <span>Learn how to upgrade <img src="images/arrow_colored_empty.png" width={15} /></span>
                  </Link>
                </div>
              </div>
            )}
          <>
            {InvoiceEarningsStatus?.toLowerCase() === "no" &&
              <Slider
                header="Gift Card"
                slides={
                  giftCards?.data?.map((giftCard, index) => (
                    <div className="featured-slide-box" key={index}>
                      <div className="featured-slide-box-image">
                        <img src={giftCard.image} alt={giftCard.title} />
                      </div>
                      <div className="featured-slide-box-inner">
                        <div className="featured-slide-box-inner-heading">
                          <h5>{giftCard.title}</h5>
                        </div>
                        <p>{giftCard.description || "No description available"}</p>
                        <div className="featured-slide-box-inner-points">
                          <p>
                            {giftCard.denominations?.length > 0
                              ? `${Math.max(...giftCard.denominations.map(d => d.fix_value))} Points`
                              : "0 Points"}
                          </p>
                        </div>
                        {/* <Link to="" className="btn btn-primary btn-block">
                    <span>Redeem Reward</span>
                  </Link> */}
                      </div>
                    </div>
                  )) || []
                }
              />
            }
          </>
          {/* <section>
        <div className="section">
          <div className="section-header">
            <h4>Learn more about Progcap rewards</h4>
          </div>
          <div className="section-video">
            <div className="video-wrapper">
              <div className="video-container" id="video-container">
                <video
                  id="video"
                  preload="metadata"
                  poster="//cdn.jsdelivr.net/npm/big-buck-bunny-1080p@0.0.6/poster.jpg"
                >
                  <source
                    src="//cdn.jsdelivr.net/npm/big-buck-bunny-1080p@0.0.6/video.mp4"
                    type="video/mp4"
                  />
                </video>
                <div className="play-button-wrapper">
                  <div title="Play video" className="play-gif" id="circle-play-b">
                    <img src="/images/play_icon.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
          {/* <section>
        <div className="section">
          <div className="section-header">
            <h4>FAQs</h4>
            <Link to="/">View All FAQs</Link>
          </div>
          {HOME_ACCORDIAN?.map((ele, idx) => (
            <div className="accordion-container" key={idx}>
              <details>
                <summary>{ele.summary}</summary>
                <div className="accordion-content">
                  <p>{ele.content}</p>
                </div>
              </details>
            </div>
          ))}
        </div>
      </section> */}
        </div>
      </main>
    </>
  );
};

export default Homepage;
